export const enum LinePosition {
  START = 'start',
  END = 'end',
}

export const getOtherLinePosition = (side: LinePosition): LinePosition =>
  side === LinePosition.START ? LinePosition.END : LinePosition.START
